<template>
	<div class="v-dialog" :style="{Width}" :size="Size">
		<div class="head">
			<div class="title">
				<slot name="title" v-if="'title' in $slots"/>
				<template v-else>{{title}}</template>
			</div>
			<div class="close" @click="$parent.close()">
				<slot name="close"/>
			</div>
		</div>
		<div class="body">
			<slot/>
		</div>
		<div class="foot">
			<slot name="foot" v-if="'foot' in $slots"/>
		</div>
	</div>
</template>

<script>
export default {
  props: {
    title: {
      default: ""
    },
    size: {
      default: ""
    }
  },
  computed: {
    Size() {
      return ["small", "large"].includes(this.size) && this.size;
    },
    Width() {
      return !this.Size && String.unit(Number(this.size) || "", "px");
    }
  }
};
</script>

<style lang="less">
.v-modal {
  > .v-dialog {
    width: 500px;
    padding: 15px;
    margin: 50px auto;
    border-radius: 4px;
    border-radius: 15px;
    margin-bottom: 50px;
    border: 1px solid #eeeeee;
    background-color: #ffffff;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
    transform: translate3d(0, 0, 0);
    transition: 300ms;
    &[size="small"] {
      width: 300px;
    }
    &[size="large"] {
      width: 800px;
    }
    &[closable] {
      > .head {
        > .close {
          display: block;
        }
      }
    }
    > .head,
    > .body,
    > .foot {
      padding: 10px;
      &:empty {
        display: none;
      }
    }
    > .head {
      padding: 10px;
      display: flex;
      align-items: flex-start;
      border-bottom: 1px solid #cccccc;
      > .title {
        flex: 1;
        font-size: 16px;
      }
      > .close {
        display: none;
        cursor: pointer;
        min-width: 18px;
        min-height: 18px;
        &:hover {
          color: #3e946a;
        }
        &:empty {
          position: relative;
          &:hover {
            &::before,
            &::after {
              background-color: #3e946a;
              transition: 300ms;
            }
          }
          &::before,
          &::after {
            top: 50%;
            left: 50%;
            width: 15px;
            height: 2px;
            content: "";
            position: absolute;
            background-color: #999999;
          }
          &::before {
            transform: translate3d(-50%, -50%, 0) rotateZ(45deg);
          }
          &::after {
            transform: translate3d(-50%, -50%, 0) rotateZ(-45deg);
          }
        }
      }
    }
    > .foot {
      text-align: right;
    }
  }
}
</style>
